import extend from 'mdui.jq/es/functions/extend';
import stateDefault from './stateDefault';
export default extend({}, stateDefault);